import {
  Box,
  Flex,
  HStack,
  Skeleton,
  SkeletonText,
  SkeletonCircle,
} from "@chakra-ui/react";
import ChannelLeadersListSkeleton from "../../molecules/ChannelLeadersList/ChannelLeadersListSkeleton";

const ChannelDetailsSkeleton = () => {
  return (
    <>
      {/* Back link + cover image (matches ChannelHeader) */}
      <Flex w="full" flexDir="column">
        <HStack mb={4} spacing={2}>
          <SkeletonCircle size="6" />
          <Skeleton height="18px" w="100px" />
        </HStack>
        <Box
          borderRadius="6px"
          display={{ base: "none", md: "block" }}
          overflow="hidden"
        >
          <Skeleton w="full" h={{ base: "180px", md: "280px" }} />
        </Box>
      </Flex>

      {/* Main layout (matches ChannelDetailsMain) */}
      <Flex
        mt={{ base: 4, md: "32px" }}
        flexDir={{ base: "column", md: "row" }}
        justify="space-between"
        gap="24px"
      >
        {/* Left: channel info section */}
        <Box>
          <Flex
            gap={{ base: "16px", md: "28px" }}
            flexDir={{ base: "column", md: "row" }}
            alignItems={{ base: "center", md: "start" }}
          >
            {/* Avatar */}
            <Box flexShrink={0} alignSelf={{ base: "center", md: "start" }}>
              <SkeletonCircle boxSize="184px" />
            </Box>
            {/* Texts */}
            <Flex
              gap="8px"
              flexDir="column"
              flex={1}
              justify={{ base: "center", md: "start" }}
            >
              <HStack spacing={3} align="center">
                <Skeleton height="28px" w="220px" />
                <SkeletonCircle size="5" />
              </HStack>
              <Flex
                align="center"
                justify={{ base: "center", md: "start" }}
                gap="16px"
                wrap="wrap"
                mb="8px"
              >
                <Skeleton height="16px" w="120px" />
                <Skeleton height="22px" w="90px" borderRadius="md" />
              </Flex>
              <Skeleton height="36px" w="120px" borderRadius="md" />
              {/* Social icons */}
              <HStack spacing={3} justify={{ base: "center", md: "start" }}>
                {Array.from({ length: 4 }).map((_, i) => (
                  <SkeletonCircle key={i} size="8" />
                ))}
              </HStack>
            </Flex>
          </Flex>
          {/* Description */}
          <Box mt="32px">
            <SkeletonText noOfLines={4} spacing="3" />
          </Box>
        </Box>

        {/* Right: leaders list card */}
        <Box mt={{ base: 4, md: 0 }} w={{ base: "100%", md: "fit-content" }}>
          <ChannelLeadersListSkeleton />
        </Box>
      </Flex>
    </>
  );
};

export default ChannelDetailsSkeleton;
